import { LOCALES, type Locale } from '@tickethub/shared';
import { Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocalePreference } from '@/lib/locale';

/**
 * Sprachumschalter de/en — Deutsch ist Standard (Spec 14).
 *
 * Schaltet sofort um und merkt sich die Wahl im Konto, sobald jemand
 * angemeldet ist (`lib/locale.ts`). Auf der Login-Seite bleibt es bei diesem
 * Geraet — dort gibt es noch kein Konto.
 */
export function LanguageSwitcher() {
  const { t } = useTranslation();
  const { locale, setLocale } = useLocalePreference();

  return (
    <label className="flex items-center gap-2 text-sm">
      <Languages className="size-4 text-muted-foreground" aria-hidden="true" />
      <span className="sr-only">{t('language.label')}</span>
      <select
        className="h-8 rounded-md border border-input bg-background px-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        value={locale}
        onChange={(event) => setLocale(event.target.value as Locale)}
      >
        {LOCALES.map((entry) => (
          <option key={entry} value={entry}>
            {t(`language.${entry}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
